var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalmartLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    role: "img",
    "aria-label": "Walmart",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 24,
    fill: "#0071DC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFC220",
    transform: "translate(64 64)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: -28,
    rx: 8,
    ry: 18
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: -28,
    rx: 8,
    ry: 18,
    transform: "rotate(60)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: -28,
    rx: 8,
    ry: 18,
    transform: "rotate(120)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: -28,
    rx: 8,
    ry: 18,
    transform: "rotate(180)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: -28,
    rx: 8,
    ry: 18,
    transform: "rotate(240)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: -28,
    rx: 8,
    ry: 18,
    transform: "rotate(300)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalmartLogo);
export default __webpack_public_path__ + "static/media/walmartLogo.c828eb93c8e24df0468b0ffd05aa1bc4.svg";
export { ForwardRef as ReactComponent };